module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://shadow.zhaogangimg.com/assets/zgkaihu/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 136);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.function.name");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/utils/filters");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/utils/rules");

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

module.exports = require("regenerator-runtime/runtime");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.for-each");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/web.dom-collections.for-each");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.number.constructor");

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.regexp.exec");

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.symbol");

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.keys");

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.to-string");

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.filter");

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.iterator");

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.slice");

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.iterator");

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/web.dom-collections.iterator");

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.regexp.to-string");

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.replace");

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.symbol.description");

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.symbol.iterator");

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.from");

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/kaihu-sms-code");

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.get-own-property-descriptor");

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.get-own-property-descriptors");

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.map");

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.find");

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/slicedToArray");

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.split");

/***/ }),
/* 33 */,
/* 34 */
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/form");

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.assign");

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/super-upDemo.5f5822f.jpg";

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/super-backup.2a6287f.jpg";

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.includes");

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.splice");

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.includes");

/***/ }),
/* 52 */,
/* 53 */
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/module-title");

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/date-rang");

/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/yingyezhizhao.da76500.png";

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.promise");

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.sort");

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.starts-with");

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "core-js/modules/es.function.name"
var es_function_name_ = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/kaihu-cmb/src/kaihu-cmb.vue?vue&type=template&id=a5a93bf0&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zg-kh-cmb" },
    [
      _c("zg-kh-form", {
        ref: "form",
        attrs: { "view-data": _vm.viewData },
        on: { bankChange: _vm.handleBankChange, input: _vm.handleInput }
      }),
      _c("beneficiary", {
        ref: "beneficiary",
        attrs: { list: _vm.beneficiaryList },
        on: { "copy-legal-person": _vm.copyLegalPerson }
      }),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px", "margin-left": "268px" } },
        [
          _c(
            "span",
            { staticStyle: { margin: "0 auto", "font-size": "12px" } },
            [
              _c("el-checkbox", {
                staticStyle: { "min-width": "14px", "margin-right": "0" },
                model: {
                  value: _vm.agree,
                  callback: function($$v) {
                    _vm.agree = $$v
                  },
                  expression: "agree"
                }
              }),
              _vm._v(
                "\n      我已阅读并同意申请找钢网&招商银行企业资金账户\n      "
              ),
              _c(
                "span",
                {
                  staticStyle: { color: "#0080ff", cursor: "pointer" },
                  on: {
                    click: function($event) {
                      _vm.visible = true
                    }
                  }
                },
                [_vm._v("用户服务协议")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "12px" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: {
                    width: "90px",
                    height: "36px",
                    "border-radius": "1px"
                  },
                  attrs: { type: "primary" },
                  on: { click: _vm.preCheck }
                },
                [_vm._v("\n        提交\n      ")]
              )
            ],
            1
          )
        ]
      ),
      _c("kaihu-agreement-cmb", {
        attrs: { "org-name": _vm.orgInfo.name, visible: _vm.visible },
        on: {
          "update:visible": function($event) {
            _vm.visible = $event
          }
        }
      }),
      _c("kaihu-sms-code", {
        ref: "smsCode",
        attrs: {
          visible: _vm.smsCode.visible,
          desc: _vm.smsCode.desc,
          maxlength: 4
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.smsCode, "visible", $event)
          },
          reset: _vm.handleCodeReset,
          finished: _vm.handleCodeFinished
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/kaihu-cmb/src/kaihu-cmb.vue?vue&type=template&id=a5a93bf0&

// EXTERNAL MODULE: external "core-js/modules/es.symbol"
var es_symbol_ = __webpack_require__(12);

// EXTERNAL MODULE: external "core-js/modules/es.symbol.description"
var es_symbol_description_ = __webpack_require__(22);

// EXTERNAL MODULE: external "core-js/modules/es.symbol.iterator"
var es_symbol_iterator_ = __webpack_require__(23);

// EXTERNAL MODULE: external "core-js/modules/es.array.filter"
var es_array_filter_ = __webpack_require__(15);

// EXTERNAL MODULE: external "core-js/modules/es.array.find"
var es_array_find_ = __webpack_require__(30);

// EXTERNAL MODULE: external "core-js/modules/es.array.for-each"
var es_array_for_each_ = __webpack_require__(8);

// EXTERNAL MODULE: external "core-js/modules/es.array.from"
var es_array_from_ = __webpack_require__(24);

// EXTERNAL MODULE: external "core-js/modules/es.array.iterator"
var es_array_iterator_ = __webpack_require__(16);

// EXTERNAL MODULE: external "core-js/modules/es.array.map"
var es_array_map_ = __webpack_require__(28);

// EXTERNAL MODULE: external "core-js/modules/es.array.slice"
var es_array_slice_ = __webpack_require__(17);

// EXTERNAL MODULE: external "core-js/modules/es.array.sort"
var es_array_sort_ = __webpack_require__(84);

// EXTERNAL MODULE: external "core-js/modules/es.number.constructor"
var es_number_constructor_ = __webpack_require__(10);

// EXTERNAL MODULE: external "core-js/modules/es.object.assign"
var es_object_assign_ = __webpack_require__(35);

// EXTERNAL MODULE: external "core-js/modules/es.object.get-own-property-descriptor"
var es_object_get_own_property_descriptor_ = __webpack_require__(26);

// EXTERNAL MODULE: external "core-js/modules/es.object.get-own-property-descriptors"
var es_object_get_own_property_descriptors_ = __webpack_require__(27);

// EXTERNAL MODULE: external "core-js/modules/es.object.keys"
var es_object_keys_ = __webpack_require__(13);

// EXTERNAL MODULE: external "core-js/modules/es.object.to-string"
var es_object_to_string_ = __webpack_require__(14);

// EXTERNAL MODULE: external "core-js/modules/es.regexp.exec"
var es_regexp_exec_ = __webpack_require__(11);

// EXTERNAL MODULE: external "core-js/modules/es.regexp.to-string"
var es_regexp_to_string_ = __webpack_require__(20);

// EXTERNAL MODULE: external "core-js/modules/es.string.iterator"
var es_string_iterator_ = __webpack_require__(18);

// EXTERNAL MODULE: external "core-js/modules/es.string.replace"
var es_string_replace_ = __webpack_require__(21);

// EXTERNAL MODULE: external "core-js/modules/web.dom-collections.for-each"
var web_dom_collections_for_each_ = __webpack_require__(9);

// EXTERNAL MODULE: external "core-js/modules/web.dom-collections.iterator"
var web_dom_collections_iterator_ = __webpack_require__(19);

// EXTERNAL MODULE: external "regenerator-runtime/runtime"
var runtime_ = __webpack_require__(7);

// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(1);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(2);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "zgkaihu/lib/form"
var form_ = __webpack_require__(34);
var form_default = /*#__PURE__*/__webpack_require__.n(form_);

// EXTERNAL MODULE: external "zgkaihu/lib/utils/filters"
var filters_ = __webpack_require__(4);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/kaihu-cmb/src/kaihu-agreement-cmb.vue?vue&type=template&id=6a068745&
var kaihu_agreement_cmbvue_type_template_id_6a068745_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "kaihu-argeement-cmb",
      attrs: { title: "", visible: _vm.visible, width: "820px", center: "" },
      on: {
        close: function($event) {
          return _vm.$emit("update:visible", false)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "protocal-title" },
        [
          _c("h2", [_vm._v("招商银行记账子单元支付结算服务协议")]),
          _c("h3", { staticStyle: { "margin-top": "20px" } }, [
            _vm._v("\n      ［系统在线签署确认］\n    ")
          ]),
          _c("p", {
            staticClass: "line",
            staticStyle: { "margin-bottom": "20px" }
          }),
          _c("el-scrollbar", [
            _c("div", { staticClass: "section-wrap" }, [
              _c("div", { staticClass: "section" }, [
                _c("p", [
                  _vm._v(
                    "\n            甲方（银行）：招商银行股份有限公司\n            "
                  ),
                  _c("span", { staticClass: "underline" }, [
                    _vm._v("上海五角场")
                  ]),
                  _vm._v("\n            分行\n          ")
                ]),
                _c("p", [
                  _vm._v("\n            乙方（平台用户）：\n            "),
                  _c("span", { staticClass: "underline" }, [
                    _vm._v(_vm._s(_vm.orgName))
                  ])
                ])
              ]),
              _c("div", { staticClass: "section" }, [
                _c("p", [
                  _vm._v(
                    "\n            基于甲方与特定电商平台的业务合作以及您（即乙方）属于该特定电商平台的正式注册用户，招商银行（即甲方）同意为该特定电商平台及您提供交易通服务。本协议由您与招商银行签署，本协议的签订视为您同意甲方为您提供本协议项下相关服务并充分知悉和理解了本协议项下的甲方、乙方、特定电商平台等各方的权利义务。\n          "
                  )
                ])
              ]),
              _c("div", { staticClass: "section" }, [
                _c("p", [
                  _c("b", [_vm._v("第一条")]),
                  _vm._v("\n            协议总体说明\n          ")
                ]),
                _c("p", [
                  _vm._v(
                    "\n            1、本协议项下主体为甲方、乙方以及与之关联的特定电商平台。乙方为特定电商平台的正式注册用户，并在该特定电商平台提供的交易系统上进行订单交易、充值/入金交易、订单支付、出金/提现交易等；甲方与特定电商平台已进行了实质性的业务合作，为特定电商平台提供了交易通服务，且双方系统实现了互联互通。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "2、正常情况下，乙方通过特定电商平台提供的服务渠道进行订单交易和相关查询。"
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            3、正常情况下，甲方主要通过特定电商平台提供的用户信息（含乙方信息）、订单交易信息、订单支付信息、清算对账类信息等进行相应的业务处理。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            4、本协议项下，乙方通过甲方使用特定电商平台向甲方交互的与乙方有关的各类信息，甲方保证只用于本协议项下服务之目的，不用做其他用途。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            5、本协议项下，基于特定电商平台进一步提升支付结算效率和交易资金管理效率的诉求或乙方的诉求，乙方作为特定电商平台的正式注册用户，通过该特定电商平台向甲方申请开立记账子单元，并按照本协议的约定依法合规使用该记账子单元，乙方同意在申请开立记账子单元的同时，在线签署并确认本协议。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            6、本协议项下，在经过甲方核验前提下，甲方基于特定电商平台交易资金见证汇总专户，为乙方开立唯一的记账子单元，乙方可以通过该平台用户记账子单元在乙方所属的特定电商平台提供的服务渠道上从事充值/入金、订单交易、出金/提现等各类服务。\n          "
                  )
                ])
              ]),
              _c("div", { staticClass: "section" }, [
                _c("p", [
                  _c("b", [_vm._v("第二条")]),
                  _vm._v("\n            相关释义\n          ")
                ]),
                _c("p", [_vm._v("除非另有约定，本协议所述下列术语释义如下：")]),
                _c("p", [
                  _vm._v(
                    "\n            1、交易通服务，是指甲方接受乙方所属特定电商平台的委托，在为乙方所属特定电商平台搭建一整套交易资金见证总分账户记账体系的同时，向乙方及其所属特定电商平台提供交易资金见证汇总专户、记账子单元的开立，记账子单元绑定、充值/入金、交易担保支付、出金/提现、交易资金清分、清算和对账等一体化资金管理服务。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            2、乙方平台用户记账子单元，是指甲方基于乙方所属特定电商平台交互的乙方用户信息，在经过甲方系统验证核实的前提下，由甲方业务系统在乙方所属特定电商平台交易资金见证汇总专户项下为乙方开立的专项用于登记核算乙方交易资金余额和交易资金变动明细的资金明细账。即甲方在乙方所属特定电商平台交易资金见证汇总专户项下为乙方开立了专属的记账子单元。乙方记账子单元，属于乙方所属特定电商平台交易资金见证汇总专户下子单元，不属于银行结算账户，乙方与甲方之间并不构成实质意义上的存款法律关系。甲方仅根据乙方及乙方所属特定电商平台的指令进行相关业务处理。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            3、乙方银行账户，是指乙方在甲方或其他银行开立的，与乙方记账子单元之间建立入金/充值或出金/提现对应绑定关系的同名实体结算账户。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            4、入金/充值，是指乙方通过线下柜台或网银等方式向其记账子单元发起充值/入金的行为，充值/入金交易处理成功的款项进入乙方所属特定电商平台在甲方处的交易资金见证汇总专户予以管控，同时系统自动将入账金额登记至乙方记账子单元下。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "5、出金/提现，是指乙方将其记账子单元内可用资金款项提现至其关联绑定的乙方银行账户。"
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "6、订单支付，是指乙方通过自身记账子单元在所属特定电商平台的服务渠道上因发起订单交易而进行的支付。"
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            7、乙方所属特定电商平台交易资金见证汇总专户，是指乙方所属特定电商平台与甲方建立银企直连时，甲方自动为乙方所属特定电商平台建立的资金见证汇总专户，用于核算乙方交易资金。在交易资金见证汇总专户下通过乙方记账子单元进一步细分核算相对应的资金款项。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            8、交易资金担保支付，是指为了解决乙方与交易对手方的信任问题，而产生的一种支付方式。乙方通过所属电商平台交易系统发起下单并支付交易时，甲方系统根据付款指令及冻结方式，进行买方或卖方冻结，并将冻结结果实时通知乙方所属特定电商平台，待乙方确认收货后再进行资金解冻及资金划转。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            9、直接支付，不同于担保支付，是指乙方在对交易订单发起支付指令时，乙方记账子单元资金直接划转至卖方记账子单元的支付。\n          "
                  )
                ])
              ]),
              _c("div", { staticClass: "section" }, [
                _c("p", [
                  _c("b", [_vm._v("第三条")]),
                  _vm._v("\n            甲方的权利义务\n          ")
                ]),
                _c("p", [
                  _vm._v(
                    "\n            1、甲方将根据甲方系统接收到的相关指令办理业务，业务处理时间以甲方在甲方系统中处理的时间为准。甲方系统接收到的指令只要是乙方通过乙方所属特定电商平台端发起的指令均视为乙方向甲方发出的有效指令，视为乙方真实意思表示，由此产生的一些后果和纠纷甲方概不负责。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "2、甲方因以下情况没有正确执行乙方指令的，不承担责任："
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "（1）甲方接收到的指令信息不明、存在论码、不完整或无法辨认等；"
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "（2）乙方记账子单元项下的可用余额不足，无法完成支付；"
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "（3）乙方记账子单元及乙方在乙方所属特定电商平台端的交易账户被依法冻结或被有权机关采取其他限制性措施；"
                  )
                ]),
                _c("p", [_vm._v("（4）乙方操作不当或操作失误；")]),
                _c("p", [_vm._v("（5）乙方所属特定电商平台的原因；")]),
                _c("p", [
                  _vm._v("（6）不可抗力或其他不可归因于甲方过失的情况。")
                ]),
                _c("p", [
                  _vm._v(
                    "3、甲方有义务维护业务系统的安全平稳运行，但不可归咎于甲方原因的情形除外。"
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            4、乙方在使用甲方服务过程中如有疑问，甲方有义务提供相应的咨询和支持，甲方有权根据业务需要更新和升级机房系统，在系统升级前，甲方将通过电商平台网站等方式予以公告。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            5、甲方提供的服务受乙方所属特定电商平台交易资金见证汇总专户，乙方记账子单元等情况的制约，如该类记账子单元因挂失、止付、冻结、可用余额不足等原因不能使用，本协议项下相关服务将终止或中止，且甲方不承担任何责任。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            6、因不可归咎于甲方的原因导致乙方所属特定电商平台中止/终止使用甲方服务的，因此导致的乙方无法完成充值/入金、支付、出金/提现等相关服务的，甲方不承担任何责任，乙方承诺其与乙方所属特定电商平台自行协商解决。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            7、甲方承诺在法律法规许可范围内使用乙方资料、用户信息和交易记录、交易支付记录等，并对乙方记账子单元项下的资金动态和相关交易支付情况严格保密，但法律、法规及监管部门另有规定的除外。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            8、乙方与乙方所属特定电商平台协议约定，暂存结算资金产生利息归乙方所属特定电商平台所有，甲方为乙方及乙方所属特定电商平台提供利息代收代付功能。\n          "
                  )
                ])
              ]),
              _c("div", { staticClass: "section" }, [
                _c("p", [
                  _c("b", [_vm._v("第四条")]),
                  _vm._v("\n            乙方权利义务\n          ")
                ]),
                _c("p", [
                  _vm._v(
                    "\n            1、乙方应妥善保管自身信息、乙方所属特定电商平台端的交易密码，不提供给他人使用，并对任何人使用所可能导致的风险和损失承担责任。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            2、乙方对向甲方系统发送的电子业务指令所涉数据内容真是性和有效性负责，对乙方与乙方所属特定电商平台、其他交易用户之间的纠纷，均与甲方无关，乙方承诺其与上述各相关方自行协调解决。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            3、乙方应在安全环境中使用甲方系统和本协议项下的服务，避免存在病毒、木马等危害性的程序，并对所使用的相关软件的合法性和安全性承担责任。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "4、乙方应对甲方提供的资料和技术方案依法承担保密义务。"
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            5、乙方在使用本协议服务过程中，所提供的资料信息如有更改，例如基本注册信息变更、预留手机号码变更、绑定的银行账号变更等，应及时按照甲方要求办理有关手续。办妥上述手续之前所产生的一切后果由乙方自行承担。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "6、乙方使用本协议项下服务时，如其使用的服务功能涉及到甲方其他业务规定或规则的需同时遵守。"
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            7、因乙方所属特定电商平台交易资金见证汇总专户、乙方记账子单元等被国家有权机关依法查询、冻结、扣划，导致甲方中止/终止本协议项下服务的，或因此给乙方造成损失的，甲方对此均不承担任何责任。\n          "
                  )
                ])
              ]),
              _c("div", { staticClass: "section" }, [
                _c("p", [
                  _c("b", [_vm._v("第五条")]),
                  _vm._v("\n            声明条款\n          ")
                ]),
                _c("p", [
                  _vm._v(
                    "\n            本协议独立于乙方与乙方所属特定电商平台双方通过各种方式签订的各类相关合同或协议，双方因上述各类合同或协议而发生的任何争议、纠纷甚至是诉讼、仲裁等，均与甲方无关，乙方承诺其与乙方所属特定电商平台自行协商解决。\n          "
                  )
                ])
              ]),
              _c("div", { staticClass: "section" }, [
                _c("p", [
                  _c("b", [_vm._v("第六条")]),
                  _vm._v("\n            不可抗力、免责及责任限制\n          ")
                ]),
                _c("p", [
                  _vm._v(
                    "因下列原因导致甲方无法正常提供本协议项下服务的，甲方不承担任何责任："
                  )
                ]),
                _c("p", [_vm._v("1、甲方系统停机维护或升级；")]),
                _c("p", [
                  _vm._v(
                    "2、因台风、地震、洪水、雷电或恐怖袭击等不可抗力原因；"
                  )
                ]),
                _c("p", [
                  _vm._v("3、用户的电脑硬件和通信线路、供电线路出现故障的；")
                ]),
                _c("p", [
                  _vm._v(
                    "4、用户操作不当或通过非甲方授权或认可的方式使用甲方系统或本协议项下服务的；"
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            5、因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、监管要求等非甲方可控的原因。\n          "
                  )
                ])
              ]),
              _c("div", { staticClass: "section" }, [
                _c("p", [
                  _c("b", [_vm._v("第七条")]),
                  _vm._v("\n            适用法律及争议解决\n          ")
                ]),
                _c("p", [
                  _vm._v(
                    "\n            1、本协议的订立、效力、履行和解释，均适用于中华人民共和国法律；法律无明文规定的，可适用通行的交易惯例。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            2、本协议未尽事宜，双方应友好协商或另行签订补充协议，因本协议引起的或与本协议有关的一切争议和纠纷，当事各方可友好协商解决，协商不成的，任何一方均可向甲方所在地人民法院提起诉讼。\n          "
                  )
                ])
              ]),
              _c("div", { staticClass: "section" }, [
                _c("p", [
                  _c("b", [_vm._v("第八条")]),
                  _vm._v("\n            协议的生效及效力\n          ")
                ]),
                _c("p", [
                  _vm._v(
                    "\n            1、本协议自乙方通过甲方认可的乙方所属特定电商平台提供的服务渠道在线确认之时起生效。乙方在上述渠道上点击确认提交即视为乙方已确认并签订了本协议。\n          "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "\n            2、除非本协议另有规定，两方中如果有其中一方需要提前终止本协议，需提前通知另外一方。甲方拟终止本协议项下服务或终止本协议的，将提前通过相关渠道进行公告或进行相应提醒；甲方明示的公告期或提醒期限内，乙方若无异议的，则本协议在甲方明示的公告期届满之日起或提醒期限届满之日起自动终止；乙方如注销记账子单元，本协议自动终止。\n          "
                  )
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "140px" },
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.$emit("update:visible", false)
                }
              }
            },
            [_vm._v("我知道了")]
          )
        ],
        1
      )
    ]
  )
}
var kaihu_agreement_cmbvue_type_template_id_6a068745_staticRenderFns = []
kaihu_agreement_cmbvue_type_template_id_6a068745_render._withStripped = true


// CONCATENATED MODULE: ./packages/kaihu-cmb/src/kaihu-agreement-cmb.vue?vue&type=template&id=6a068745&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/kaihu-cmb/src/kaihu-agreement-cmb.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var kaihu_agreement_cmbvue_type_script_lang_js_ = ({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orgName: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/kaihu-cmb/src/kaihu-agreement-cmb.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_kaihu_agreement_cmbvue_type_script_lang_js_ = (kaihu_agreement_cmbvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/kaihu-cmb/src/kaihu-agreement-cmb.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_kaihu_agreement_cmbvue_type_script_lang_js_,
  kaihu_agreement_cmbvue_type_template_id_6a068745_render,
  kaihu_agreement_cmbvue_type_template_id_6a068745_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/kaihu-cmb/src/kaihu-agreement-cmb.vue"
/* harmony default export */ var kaihu_agreement_cmb = (component.exports);
// EXTERNAL MODULE: external "zgkaihu/lib/kaihu-sms-code"
var kaihu_sms_code_ = __webpack_require__(25);
var kaihu_sms_code_default = /*#__PURE__*/__webpack_require__.n(kaihu_sms_code_);

// EXTERNAL MODULE: external "zgkaihu/lib/utils/rules"
var rules_ = __webpack_require__(5);
var rules_default = /*#__PURE__*/__webpack_require__.n(rules_);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/kaihu-cmb/src/beneficiary.vue?vue&type=template&id=278e8ea2&
var beneficiaryvue_type_template_id_278e8ea2_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "beneficiary-card" },
    [
      _c("module-title", { attrs: { title: "企业受益人信息" } }),
      _vm._l(_vm.list, function(form, index) {
        return _c(
          "el-form",
          {
            key: index,
            ref: "form",
            refInFor: true,
            staticClass: "zg-kh-form",
            attrs: { "label-width": "268px", rules: _vm.rules, model: form }
          },
          [
            _c("div", { staticClass: "beneficiary-item" }, [
              _c("span", [_vm._v(_vm._s("受益人" + (index + 1)))]),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.list.length > 1,
                      expression: "list.length > 1"
                    }
                  ],
                  staticClass: "c-9 pointer",
                  on: {
                    click: function($event) {
                      return _vm.deleteBeneficiary(index)
                    }
                  }
                },
                [_vm._v("删除")]
              )
            ]),
            _c(
              "el-form-item",
              {
                staticClass: "zg-kh-form-item-radio",
                attrs: { label: "受益人身份", prop: "managerType" }
              },
              [
                _c(
                  "el-radio-group",
                  {
                    on: {
                      change: function(val) {
                        return _vm.handleManagerTypeChange(val, form)
                      }
                    },
                    model: {
                      value: form.managerType,
                      callback: function($$v) {
                        _vm.$set(form, "managerType", $$v)
                      },
                      expression: "form.managerType"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [
                      _vm._v("法定代表人")
                    ]),
                    _c("el-radio", { attrs: { label: 2 } }, [
                      _vm._v("非法定代表人/个体经营者")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: form.managerType === 1,
                    expression: "form.managerType === 1"
                  }
                ],
                staticClass: "zg-kh-form-tips"
              },
              [
                _c("img", {
                  staticClass: "zg-kh-form-tips-icon",
                  attrs: { src: __webpack_require__(56) }
                }),
                _c("span", { staticClass: "zg-kh-form-tips-content" }, [
                  _vm._v(
                    "企业受益人为法定代表人时，若受益人信息有误，请修改法定代表人信息。"
                  )
                ])
              ]
            ),
            _c(
              "el-form-item",
              {
                staticClass: "zg-kh-form-input",
                attrs: { label: "证件类型", prop: "identityType" }
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: { disabled: form.managerType === 1 },
                    model: {
                      value: form.identityType,
                      callback: function($$v) {
                        _vm.$set(form, "identityType", $$v)
                      },
                      expression: "form.identityType"
                    }
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "中国⼤陆居⺠身份证", value: 1 }
                    }),
                    _c("el-option", {
                      attrs: { label: "中国⾹港居⺠来往内地通⾏证 ", value: 3 }
                    }),
                    _c("el-option", {
                      attrs: { label: "中国澳⻔居⺠来往内地通⾏证", value: 4 }
                    }),
                    _c("el-option", {
                      attrs: { label: "中国台湾居⺠来往⼤陆通⾏证", value: 5 }
                    }),
                    _c("el-option", {
                      attrs: { label: "其他国家或地区居⺠护照", value: 2 }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "zg-kh-form-input",
                attrs: { label: "受益人姓名", prop: "name" }
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "请输入受益人姓名",
                    disabled: form.managerType === 1
                  },
                  model: {
                    value: form.name,
                    callback: function($$v) {
                      _vm.$set(
                        form,
                        "name",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.name"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "zg-kh-form-input",
                attrs: { label: "受益人证件号", prop: "idCard" }
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "请输入受益人证件号",
                    disabled: form.managerType === 1
                  },
                  model: {
                    value: form.idCard,
                    callback: function($$v) {
                      _vm.$set(
                        form,
                        "idCard",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.idCard"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "zg-kh-form-daterang",
                attrs: { label: "受益人证件有效期", prop: "dateRang" }
              },
              [
                _c("date-rang", {
                  attrs: {
                    data: form.dateRang,
                    "picker-options": _vm.pickerOptions
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "zg-kh-form-input",
                attrs: { label: "受益/控制方式", prop: "benefitType" }
              },
              [
                _c(
                  "el-select",
                  {
                    model: {
                      value: form.benefitType,
                      callback: function($$v) {
                        _vm.$set(form, "benefitType", $$v)
                      },
                      expression: "form.benefitType"
                    }
                  },
                  [
                    _c("el-option", { attrs: { label: "股权", value: 1 } }),
                    _c("el-option", { attrs: { label: "投票权", value: 2 } }),
                    _c("el-option", { attrs: { label: "财务 ", value: 3 } }),
                    _c("el-option", { attrs: { label: "人事", value: 4 } }),
                    _c("el-option", { attrs: { label: "协议", value: 5 } }),
                    _c("el-option", { attrs: { label: "权益", value: 6 } }),
                    _c("el-option", { attrs: { label: "事实控制", value: 7 } }),
                    _c("el-option", { attrs: { label: "受益权", value: 8 } }),
                    _c("el-option", { attrs: { label: "其它", value: 0 } })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "zg-kh-form-input",
                attrs: { label: "受益比例", prop: "benefitRatio" }
              },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入受益比例" },
                  on: {
                    input: function(val) {
                      return _vm.handleBenefitRatioInput(val, form)
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "suffix",
                        fn: function() {
                          return [_c("span", [_vm._v("%")])]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: form.benefitRatio,
                    callback: function($$v) {
                      _vm.$set(
                        form,
                        "benefitRatio",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.benefitRatio"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "zg-kh-form-input",
                attrs: { label: "受益人电话", prop: "phone" }
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "请输入受益人电话",
                    disabled: form.managerType === 1
                  },
                  model: {
                    value: form.phone,
                    callback: function($$v) {
                      _vm.$set(
                        form,
                        "phone",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.phone"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "zg-kh-form-input",
                attrs: { label: "受益人地址", prop: "address" }
              },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入受益人地址" },
                  model: {
                    value: form.address,
                    callback: function($$v) {
                      _vm.$set(
                        form,
                        "address",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.address"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "beneficiary-bottom" })
          ],
          1
        )
      }),
      _c(
        "el-button",
        {
          staticClass: "m-l80 fw-400 f-13",
          staticStyle: { padding: "0" },
          attrs: { type: "text", icon: "el-icon-plus" },
          on: { click: _vm.addBenuficiary }
        },
        [_vm._v("\n    添加受益人\n  ")]
      )
    ],
    2
  )
}
var beneficiaryvue_type_template_id_278e8ea2_staticRenderFns = []
beneficiaryvue_type_template_id_278e8ea2_render._withStripped = true


// CONCATENATED MODULE: ./packages/kaihu-cmb/src/beneficiary.vue?vue&type=template&id=278e8ea2&

// EXTERNAL MODULE: external "core-js/modules/es.array.includes"
var es_array_includes_ = __webpack_require__(49);

// EXTERNAL MODULE: external "core-js/modules/es.array.splice"
var es_array_splice_ = __webpack_require__(50);

// EXTERNAL MODULE: external "core-js/modules/es.promise"
var es_promise_ = __webpack_require__(67);

// EXTERNAL MODULE: external "core-js/modules/es.string.includes"
var es_string_includes_ = __webpack_require__(51);

// EXTERNAL MODULE: external "core-js/modules/es.string.split"
var es_string_split_ = __webpack_require__(32);

// EXTERNAL MODULE: external "core-js/modules/es.string.starts-with"
var es_string_starts_with_ = __webpack_require__(85);

// EXTERNAL MODULE: external "@babel/runtime/helpers/slicedToArray"
var slicedToArray_ = __webpack_require__(31);
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_);

// EXTERNAL MODULE: external "zgkaihu/lib/module-title"
var module_title_ = __webpack_require__(53);
var module_title_default = /*#__PURE__*/__webpack_require__.n(module_title_);

// EXTERNAL MODULE: external "zgkaihu/lib/date-rang"
var date_rang_ = __webpack_require__(54);
var date_rang_default = /*#__PURE__*/__webpack_require__.n(date_rang_);

// CONCATENATED MODULE: ./packages/kaihu-cmb/src/utils.js


/* harmony default export */ var utils = ({
  getBeneficiary: function getBeneficiary() {
    return {
      managerType: 2,
      identityType: 1,
      name: '',
      idCard: '',
      dateRang: {
        start: '',
        end: '',
        long: false
      },
      idCardIssueDate: '',
      idCardEndDate: '',
      idCardForeverFlag: 0,
      benefitType: 1,
      benefitRatio: '',
      phone: '',
      address: ''
    };
  }
});
var outOrgTypeEnum = {
  '01': '企业法人',
  '02': '非法人企业',
  '03': '事业单位',
  '04': '团(含)以上军队及分散执勤的支(分)队',
  '05': '社会团体',
  '06': '民办非企业组织',
  '07': '异地常设机构',
  '08': '外国驻华机构',
  '09': '个体工商户',
  '10': '居委会、村委会、社区委员会',
  '11': '单位设立的独立核算附属机构',
  '12': '其他组织',
  '13': '合伙人',
  '14': '境外个人',
  '15': '机关法人',
  '16': '农民专业合作社'
};
var ownerShipEnum = {
  '1000': '公有控股经济',
  '1100': '国有控股',
  '1110': '国有绝对控股',
  '1111': '国有绝对控股(国资委直属央企)',
  '1112': '国有绝对控股(中央直管,央企除外)',
  '1113': '国有绝对控股(地方管理)',
  '1120': '国有相对控股',
  '1121': '国有相对控股(国资委直属央企)',
  '1122': '国有相对控股(中央直管,央企除外)',
  '1123': '国有相对控股(地方管理)',
  '1200': '集体控股',
  '1210': '集体绝对控股',
  '1220': '集体相对控股',
  '2000': '非公有控股经济',
  '2100': '境内私人控股',
  '2110': '境内私人绝对控股',
  '2120': '境内私人相对控股',
  '2200': '港澳台商控股',
  '2210': '港澳台商绝对控股',
  '2220': '港澳台商相对控股',
  '2300': '外商控股',
  '2310': '外商绝对控股',
  '2320': '外商相对控股'
};
var enpSizeEnum = {
  A: '大型',
  B: '中型',
  C: '中小型',
  D: '小型',
  E: '微小型'
};
var toLabelValue = function toLabelValue(obj) {
  return Object.keys(obj).map(function (key) {
    return {
      label: obj[key],
      value: key
    };
  });
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/kaihu-cmb/src/beneficiary.vue?vue&type=script&lang=js&
























function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var beneficiaryvue_type_script_lang_js_ = ({
  name: 'Beneficiary',
  components: {
    ModuleTitle: module_title_default.a,
    DateRang: date_rang_default.a
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      rules: {
        managerType: rules_default.a.required('请选择受益人身份', ['blur', 'change']),
        identityType: rules_default.a.required('请选择证件类型', ['blur', 'change']),
        name: rules_default.a.required('请输入受益人姓名', ['blur', 'change']),
        idCard: rules_default.a.required('请输入受益人证件号码', ['blur', 'change']),
        dateRang: rules_default.a.dateRang('请选择受益人证件有效期', ['blur', 'change']),
        benefitType: rules_default.a.required('请选择受益/控制方式', ['blur', 'change']),
        benefitRatio: {
          required: true,
          validator: function validator(rule, val, callback) {
            if (val === undefined || val === '' || val === null || Number(val) > 100) {
              return callback(new Error('收益比例不能为空，不能大于100'));
            }

            callback();
          }
        },
        phone: rules_default.a.telephone('请输入受益人电话', ['blur', 'change']),
        address: rules_default.a.required('请输入受益人地址', ['blur', 'change'])
      },
      pickerOptions: {
        startOptions: {
          disabledDate: function disabledDate(time) {
            return time.getTime() > Date.now();
          }
        },
        endOptions: {
          disabledDate: function disabledDate(time) {
            return time.getTime() < Date.now();
          }
        }
      }
    };
  },
  methods: {
    validate: function validate() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var forms = _this.$refs.form;
        var isOk = true;

        var _iterator = _createForOfIteratorHelper(forms),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var form = _step.value;
            form.validate(function (isSuccess, error) {
              if (!isSuccess) {
                var keys = Object.keys(error);

                _this.$message.error(error[keys[0]][0].message);

                isOk = false;
              }
            });

            if (!isOk) {
              reject();
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        resolve();
      });
    },
    deleteBeneficiary: function deleteBeneficiary(index) {
      this.list.splice(index, 1);
    },
    addBenuficiary: function addBenuficiary() {
      if (this.list.length < 5) {
        this.list.push(utils.getBeneficiary());
      } else {
        this.$message.error('最多添加5个受益人');
      }
    },
    handleBenefitRatioInput: function handleBenefitRatioInput(val, form) {
      form.benefitRatio = this.amount(val);
    },
    handleManagerTypeChange: function handleManagerTypeChange(val, form) {
      if (val === 1 && this.list.filter(function (item) {
        return item.managerType === 1;
      }).length === 2) {
        form.managerType = 2;
        return this.$message.error('已经存在受益人是法定代表人的信息');
      }

      form.identityType = 1;
      form.managerType = val;
      form.name = '';
      form.idCard = '';
      form.phone = '';

      if (val === 1) {
        this.$emit('copy-legal-person', form);
      }
    },
    spLimit: function spLimit(str, leftLength, rightLength) {
      var start = '';

      if (str.startsWith('-')) {
        start = '-';
        str = str.slice(1).replace(/-/g, '');
      } else {
        str = str.replace(/-/g, '');
      }

      if (str.includes('.')) {
        var _str$split = str.split('.'),
            _str$split2 = slicedToArray_default()(_str$split, 2),
            lStr = _str$split2[0],
            rStr = _str$split2[1];

        return start + lStr.slice(0, leftLength) + '.' + rStr.slice(0, rightLength);
      } else {
        return start + str.slice(0, leftLength);
      }
    },
    amount: function amount(num) {
      var leftLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
      var minusType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      try {
        var reg = /[^\d.]/g;

        if (minusType) {
          reg = /[^\d.-]/g;
        }

        var str = (num + '').replace(/。/g, '.') // 兼容处理，输入法输入数字时会将“。”转成“.”，但退格等其他情况不会，造成不统一。
        .replace(reg, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
        return this.spLimit(str, leftLength, 2);
      } catch (e) {
        return '0';
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/kaihu-cmb/src/beneficiary.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_beneficiaryvue_type_script_lang_js_ = (beneficiaryvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/kaihu-cmb/src/beneficiary.vue





/* normalize component */

var beneficiary_component = Object(componentNormalizer["a" /* default */])(
  src_beneficiaryvue_type_script_lang_js_,
  beneficiaryvue_type_template_id_278e8ea2_render,
  beneficiaryvue_type_template_id_278e8ea2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var beneficiary_api; }
beneficiary_component.options.__file = "packages/kaihu-cmb/src/beneficiary.vue"
/* harmony default export */ var src_beneficiary = (beneficiary_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/kaihu-cmb/src/kaihu-cmb.vue?vue&type=script&lang=js&




























var _components;

function kaihu_cmbvue_type_script_lang_js_createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = kaihu_cmbvue_type_script_lang_js_unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function kaihu_cmbvue_type_script_lang_js_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return kaihu_cmbvue_type_script_lang_js_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return kaihu_cmbvue_type_script_lang_js_arrayLikeToArray(o, minLen); }

function kaihu_cmbvue_type_script_lang_js_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var outOrgTypeOptions = toLabelValue(outOrgTypeEnum).sort(function (a, b) {
  return Number(a.value) - Number(b.value);
});
var ownerShipOptions = toLabelValue(ownerShipEnum);
var enpSizeOptions = toLabelValue(enpSizeEnum);
/* harmony default export */ var kaihu_cmbvue_type_script_lang_js_ = ({
  name: 'KaihuCmb',
  components: (_components = {}, defineProperty_default()(_components, form_default.a.name, form_default.a), defineProperty_default()(_components, "KaihuAgreementCmb", kaihu_agreement_cmb), defineProperty_default()(_components, "KaihuSmsCode", kaihu_sms_code_default.a), defineProperty_default()(_components, "Beneficiary", src_beneficiary), _components),
  props: {
    orgInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    userId: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      smsCode: {
        visible: false,
        desc: ''
      },
      visible: false,
      agree: true,
      viewData: [{
        type: 'title',
        title: '企业信息'
      }, {
        type: 'display',
        label: '企业名称',
        key: 'orgRealName',
        value: ''
      }, {
        type: 'input',
        label: '统一社会信用代码',
        key: 'csdCode',
        value: '',
        placeholder: '请输入15位或18位营业执照注册号',
        maxlength: 18,
        rules: rules_default.a.csdCode()
      }, {
        type: 'input',
        label: '注册地址',
        key: 'registerAddress',
        value: '',
        placeholder: '请输入企业注册地址',
        maxlength: 125,
        rules: rules_default.a.required('请输入企业注册地址')
      }, {
        type: 'input',
        label: '实际办公地址',
        key: 'actualOfficeAddress',
        value: '',
        placeholder: '请输入企业实际办公地址',
        maxlength: 125,
        rules: rules_default.a.required('请输入企业实际办公地址')
      }, {
        type: 'input',
        label: '企业联系电话',
        key: 'mobile',
        value: '',
        maxlength: 15,
        rules: rules_default.a.telephone('企业联系电话')
      }, {
        type: 'radio',
        label: '是否我行贷款客户',
        key: 'isCmbLoanCustomer',
        value: '',
        rules: rules_default.a.required('请选择是否我行贷款客户', 'change'),
        options: [{
          label: '是',
          value: 'Y'
        }, {
          label: '否',
          value: 'N'
        }]
      }, {
        type: 'radio',
        label: '是否上市公司',
        key: 'isListedEnp',
        value: '',
        rules: rules_default.a.required('请选择是否上市公司', 'change'),
        options: [{
          label: '是',
          value: 'Y'
        }, {
          label: '否',
          value: 'N'
        }]
      }, {
        type: 'select',
        label: '机构类型',
        key: 'outOrgType',
        value: '',
        rules: rules_default.a.required('请选择机构类型', 'change'),
        options: outOrgTypeOptions
      }, {
        type: 'select',
        label: '所有制性质',
        key: 'ownerShip',
        value: '',
        rules: rules_default.a.required('请选择所有制性质', 'change'),
        options: ownerShipOptions
      }, {
        type: 'select',
        label: '企业规模',
        key: 'enpSize',
        value: '',
        rules: rules_default.a.required('请选择企业规模', 'change'),
        options: enpSizeOptions
      }, {
        type: 'upload',
        label: '上传附件',
        key: 'businessLicence',
        value: {
          fk: ''
        },
        example: {
          url: __webpack_require__(57)
        },
        tips: '请上传营业执照正本或副本扫描图片1张，只支持JPG格式，文件大小不能超过2M',
        config: {
          label: '营业执照（正/副本照）',
          accept: ['jpg'],
          maxSize: 2 * 1024 * 1024,
          compressSize: 1024
        },
        rules: {
          required: true
        }
      }, {
        type: 'title',
        title: '绑定账户信息'
      }, {
        type: 'tips',
        title: '只能绑定银行同户名实体结算账户，此账户将用于打款认证、账户充值、余额提现'
      }, {
        type: 'bank',
        key: 'bank',
        value: {},
        channelCode: 50002,
        rules: {
          required: true
        }
      }, {
        type: 'input',
        label: '银行账号',
        key: 'bankNo',
        value: '',
        maxlength: 30,
        rules: {
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error('请输入银行账号'));
            } else if (/^[0-9]+$/.test(value)) {
              callback();
            } else {
              callback(new Error('请输入正确的银行账号'));
            }
          },
          trigger: 'blur'
        }
      }, {
        type: 'address',
        key: 'address',
        value: {},
        label: '开户地址',
        maxLevel: 1,
        placeholder: '请选择省市',
        rules: {
          required: true,
          validator: function validator(rule, value, callback) {
            if (value.selected && value.selected.length > 0) {
              callback();
            } else {
              callback(new Error('请选择开户地址'));
            }
          },
          trigger: 'change'
        }
      }, {
        type: 'display',
        label: '开户行号',
        key: 'openBankNo',
        value: ''
      }, {
        type: 'title',
        title: '法定代表人信息'
      }, {
        type: 'input',
        label: '法人代表',
        key: 'legalPerson',
        value: '',
        placeholder: '请输入法人姓名',
        maxlength: 20,
        rules: rules_default.a.required('请输入法人姓名')
      }, {
        type: 'input',
        label: '法人证件号',
        key: 'identityNo',
        value: '',
        placeholder: '请输入法人身份证号',
        maxlength: 18,
        rules: rules_default.a.idNumber('法人身份证号')
      }, {
        type: 'input',
        label: '法人手机号',
        key: 'legalMobile',
        value: '',
        maxlength: 11,
        rules: rules_default.a.mobile('法人手机号')
      }, {
        type: 'upload',
        label: '法人身份证照',
        key: 'identityCardA',
        datas: [{
          key: 'identityCardA',
          value: {
            fk: ''
          },
          example: {
            url: __webpack_require__(41)
          },
          config: {
            label: '个人信息页',
            accept: ['jpg'],
            maxSize: 2 * 1024 * 1024,
            compressSize: 1024
          }
        }, {
          key: 'identityCardB',
          value: {
            fk: ''
          },
          example: {
            url: __webpack_require__(42)
          },
          tips: '请上传法人身份证扫描图片，只支持JPG格式，文件大小不能超过2M',
          config: {
            label: '国徽页',
            accept: ['jpg'],
            maxSize: 2 * 1024 * 1024,
            compressSize: 1024
          }
        }],
        rules: {
          required: true
        }
      }, {
        type: 'title',
        title: '经办人信息'
      }, {
        type: 'input',
        label: '经办人姓名',
        key: 'agent',
        value: '',
        maxlength: 15,
        rules: rules_default.a.required('请输入经办人姓名')
      }, {
        type: 'input',
        label: '经办人身份证号',
        key: 'agentCertificateNo',
        value: '',
        maxlength: 18,
        rules: rules_default.a.idNumber('经办人身份证号')
      }, {
        type: 'date',
        label: '经办人证件有效期',
        key: 'agentDate',
        mapper: {
          date: 'agentExpiryDate',
          long: 'agesFlag'
        },
        value: {
          date: '',
          long: false
        },
        longTerm: true,
        pickerOptions: {
          disabledDate: function disabledDate(time) {
            return time.getTime() < Date.now();
          }
        },
        rules: {
          required: true,
          validator: function validator(rule, value, callback) {
            if (value.date || value.long) {
              callback();
            } else {
              callback(new Error('请选择经办人证件有效期'));
            }
          },
          trigger: 'change'
        }
      }, {
        type: 'input',
        label: '经办人手机号',
        key: 'agentPhone',
        value: '',
        maxlength: 11,
        tips: '用于发起交易时接收动态密码，可前往用户中心进行更换经办人手机号。',
        rules: rules_default.a.mobile('经办人手机号码')
      }, {
        type: 'input',
        label: '联系地址',
        key: 'contactAddress',
        value: '',
        maxlength: 40
      }, {
        type: 'upload',
        label: '经办人证件照',
        key: 'agentFile',
        datas: [{
          key: 'agentIdentityCardA',
          value: {
            fk: ''
          },
          example: {
            url: __webpack_require__(41)
          },
          config: {
            label: '个人信息页',
            accept: ['jpg'],
            maxSize: 2 * 1024 * 1024,
            compressSize: 1024
          }
        }, {
          key: 'agentIdentityCardB',
          value: {
            fk: ''
          },
          example: {
            url: __webpack_require__(42)
          },
          tips: '请上传经办人身份证扫描图片，只支持JPG格式，文件大小不能超过2M',
          config: {
            label: '国徽页',
            accept: ['jpg'],
            maxSize: 2 * 1024 * 1024,
            compressSize: 1024
          }
        }],
        rules: {
          required: true
        }
      }, {
        type: 'upload',
        label: '上传附件',
        key: 'powerOfAttorney',
        tips: '请上传授权委托书扫描图片，只支持JPG格式，文件大小不能超过2M',
        value: {
          fk: ''
        },
        template: {
          url: 'https://shadow.zhaogangimg.com/assets/hawk/V2-%E6%8E%88%E6%9D%83%E5%A7%94%E6%89%98%E4%B9%A6(%E6%89%BE%E9%92%A2%E7%BD%91)-%E6%8B%9B%E8%A1%8C.doc'
        },
        config: {
          label: '授权委托书',
          accept: ['jpg'],
          maxSize: 2 * 1024 * 1024,
          compressSize: 1024
        },
        rules: {
          required: true
        }
      }],
      beneficiaryList: [utils.getBeneficiary()]
    };
  },
  mounted: function mounted() {
    var orgEle = this.getElementByKey('orgRealName');
    orgEle.value = this.orgInfo.name;
    this.$refs.form.setModelValue(orgEle.key, orgEle.value);
    this.getInfoById();
  },
  methods: {
    getElementByKey: function getElementByKey(key) {
      return this.viewData.find(function (item) {
        return item.key === key;
      });
    },
    handleInput: function handleInput(ele) {
      var form = this.beneficiaryList.find(function (item) {
        return item.managerType === 1;
      });

      if (form) {
        if (ele.key === 'legalPerson') {
          form.name = ele.value;
        }

        if (ele.key === 'identityNo') {
          form.idCard = ele.value;
        }

        if (ele.key === 'legalMobile') {
          form.phone = ele.value;
        }
      }
    },
    copyLegalPerson: function copyLegalPerson(form) {
      form.name = this.getElementByKey('legalPerson').value;
      form.idCard = this.getElementByKey('identityNo').value;
      form.phone = this.getElementByKey('legalMobile').value;
    },
    handleBankChange: function handleBankChange(obj) {
      if (obj.key === 'branch') {
        var ele = this.getElementByKey('openBankNo');
        var value = obj.branch ? obj.branch.bankNumberCode : '';
        ele.value = value;
        this.$refs.form.setModelValue(ele.key, ele.value);
      }
    },
    getInfoById: function getInfoById() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp, _this$$zgKaihu$$conve, success, data, _data$applyManagers, applyManagers, _data$orgAuditExtResu, orgAuditExtResult;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.$route.query.id) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return _this.$zgKaihu.$get('apply.getOrgAuditInfoById', {
                  id: _this.$route.query.id
                });

              case 5:
                resp = _context.sent;
                _this$$zgKaihu$$conve = _this.$zgKaihu.$convertResp(resp), success = _this$$zgKaihu$$conve.success, data = _this$$zgKaihu$$conve.data;

                if (success && data) {
                  _this.setViewDataInfo(_objectSpread({}, data, {}, data.orgAuditExtResult)); //受益人


                  _data$applyManagers = data.applyManagers, applyManagers = _data$applyManagers === void 0 ? [] : _data$applyManagers, _data$orgAuditExtResu = data.orgAuditExtResult, orgAuditExtResult = _data$orgAuditExtResu === void 0 ? {} : _data$orgAuditExtResu;

                  if (applyManagers.length > 0) {
                    _this.beneficiaryList = applyManagers.map(function (item) {
                      var beneficiary = utils.getBeneficiary();
                      Object.assign(beneficiary, item);
                      delete beneficiary.managerId;
                      delete beneficiary.orgAuditId;
                      beneficiary.dateRang.start = Object(filters_["parseTime"])(beneficiary.idCardIssueDate, '{y}-{M}-{d}');

                      if (beneficiary.idCardEndDate) {
                        beneficiary.dateRang.end = Object(filters_["parseTime"])(beneficiary.idCardEndDate, '{y}-{M}-{d}');
                      }

                      beneficiary.dateRang.long = !!beneficiary.idCardForeverFlag;
                      return beneficiary;
                    });
                  }
                }

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);
                console.log(_context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 10]]);
      }))();
    },
    setViewDataInfo: function setViewDataInfo(data) {
      var mapping = {
        orgRealName: 'corpName'
      };

      var _iterator = kaihu_cmbvue_type_script_lang_js_createForOfIteratorHelper(this.viewData),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var ele = _step.value;
          if (!ele.key) continue;

          if (ele.type === 'date') {
            ele.value.date = data[ele.mapper.date];
            ele.value.long = data[ele.mapper.long] ? true : false;
          } else if (ele.type === 'address') {
            if (data.citys) {
              this.$refs.form.setAddressValue(ele.key, data.citys);
            }
          } else if (ele.type === 'bank') {
            this.$refs.form.setBankValue(ele.key, {
              bankName: data.bankName,
              branchName: data.openBank
            });
          } else if (ele.type === 'upload') {
            if (ele.datas) {
              ele.datas.forEach(function (item) {
                item.value.fk = data[item.key];
              });
            } else {
              ele.value.fk = data[ele.key];
            }
          } else {
            var value = mapping[ele.key] ? data[mapping[ele.key]] : data[ele.key];
            ele.value = value;
            this.$refs.form.setModelValue(ele.key, ele.value);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    preCheck: function preCheck() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (_this2.$refs.form.validate()) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                _context2.next = 5;
                return _this2.$refs.beneficiary.validate();

              case 5:
                if (_this2.agree) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", _this2.$message.error('请阅读并同意用户服务协议'));

              case 7:
                _this2.sendSmsCode();

                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 10]]);
      }))();
    },
    sendSmsCode: function sendSmsCode() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var default_desc, phone, resp, _this3$$zgKaihu$$conv, success, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                default_desc = '验证码已发至%s，有效期10分钟。';
                phone = _this3.getElementByKey('agentPhone').value;
                _context3.next = 5;
                return _this3.$zgKaihu.$get('apply.sendSmsIdentifyCode', {
                  mobile: phone
                });

              case 5:
                resp = _context3.sent;
                _this3$$zgKaihu$$conv = _this3.$zgKaihu.$convertResp(resp), success = _this3$$zgKaihu$$conv.success, data = _this3$$zgKaihu$$conv.data;

                if (success && data.value) {
                  if (_this3.smsCode.visible) {
                    _this3.$refs.smsCode.resetCountDown();
                  } else {
                    _this3.smsCode.desc = default_desc.replace('%s', phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'));
                    _this3.smsCode.visible = true;
                  }
                }

                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);
                console.log(_context3.t0);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 10]]);
      }))();
    },
    handleCodeReset: function handleCodeReset() {
      this.sendSmsCode();
    },
    handleCodeFinished: function handleCodeFinished(smsCode) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, resp, _this4$$zgKaihu$$conv, success, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                params = _this4.getReqParams();
                params.smsCode = smsCode;
                params.auditType = 10;
                params.signType = 1;
                params.uid = _this4.userId;
                _context4.next = 8;
                return _this4.$zgKaihu.$get('apply.submitAuth', {
                  submitAuthParam: params
                });

              case 8:
                resp = _context4.sent;
                _this4$$zgKaihu$$conv = _this4.$zgKaihu.$convertResp(resp), success = _this4$$zgKaihu$$conv.success, data = _this4$$zgKaihu$$conv.data;

                if (success) {
                  if (data.success) {
                    _this4.smsCode.visible = false;

                    _this4.$emit('success', data.orgEnterId);
                  } else {
                    data.errorMessage && _this4.$message.error(data.errorMessage);
                  }
                }

                _context4.next = 16;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](0);
                console.log(_context4.t0);

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 13]]);
      }))();
    },
    getReqParams: function getReqParams() {
      var params = {};

      var _iterator2 = kaihu_cmbvue_type_script_lang_js_createForOfIteratorHelper(this.viewData),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var ele = _step2.value;
          if (!ele.key) continue;

          if (ele.type === 'bank') {
            params.bankName = ele.value.bank.bankFullName;
            params.bankCode = ele.value.bank.bankCode;
            params.openBank = ele.value.branch.bankBranchName;
            params.openBankNo = ele.value.branch.bankNumberCode;
          } else if (ele.type === 'address') {
            params.citys = ele.value.selected[0].provinceName;
          } else if (ele.type === 'date') {
            params[ele.mapper.date] = ele.value.date;
            params[ele.mapper.long] = ele.value.long ? 1 : 0;
          } else if (ele.type === 'upload') {
            if (ele.datas) {
              ele.datas.forEach(function (item) {
                return params[item.key] = item.value.fk;
              });
            } else {
              params[ele.key] = ele.value.fk;
            }
          } else {
            params[ele.key] = ele.value;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      params.uboListParam = this.beneficiaryList.map(function (item) {
        var row = _objectSpread({}, item);

        row.idCardIssueDate = row.dateRang.start;
        row.idCardEndDate = row.dateRang.end;
        row.idCardForeverFlag = row.dateRang.long ? 1 : 0;
        delete row.dateRang;
        return row;
      });
      return params;
    }
  }
});
// CONCATENATED MODULE: ./packages/kaihu-cmb/src/kaihu-cmb.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_kaihu_cmbvue_type_script_lang_js_ = (kaihu_cmbvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/kaihu-cmb/src/kaihu-cmb.vue





/* normalize component */

var kaihu_cmb_component = Object(componentNormalizer["a" /* default */])(
  src_kaihu_cmbvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var kaihu_cmb_api; }
kaihu_cmb_component.options.__file = "packages/kaihu-cmb/src/kaihu-cmb.vue"
/* harmony default export */ var kaihu_cmb = (kaihu_cmb_component.exports);
// CONCATENATED MODULE: ./packages/kaihu-cmb/index.js



kaihu_cmb.install = function (Vue) {
  Vue.component(kaihu_cmb.name, kaihu_cmb);
};

/* harmony default export */ var packages_kaihu_cmb = __webpack_exports__["default"] = (kaihu_cmb);

/***/ })
/******/ ]);